export default {
  index: [
    {
      path: '/edepartment',
      component: resolve => require(['./edepartmentIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/edepartment/_router.js